const operandData =[ { value: 'A', id: 'block-1' },
{ value: 'B', id: 'block-1' },
{ value: 'C', id: 'block-1' },
{ value: 'D', id: 'block-1' },
{ value: 'E', id: 'block-1' },
{ value: 'F', id: 'block-1' },
{ value: 'G', id: 'block-1' },
{ value: 'H', id: 'block-1' },
{ value: 'I', id: 'block-1' },
{ value: 'J', id: 'block-1' },
{ value: 'K', id: 'block-1' },
{ value: 'L', id: 'block-1' },
{ value: 'M', id: 'block-1' },
{ value: 'N', id: 'block-1' },
{ value: 'O', id: 'block-1' },
{ value: 'P', id: 'block-1' },
{ value: 'Q', id: 'block-1' },
{ value: 'R', id: 'block-1' },
{ value: 'S', id: 'block-1' },
{ value: 'T', id: 'block-1' },
{ value: 'U', id: 'block-1' },
{ value: 'V', id: 'block-1' },
{ value: 'W', id: 'block-1' },
{ value: 'X', id: 'block-1' },
{ value: 'Y', id: 'block-1' },
{ value: 'Z', id: 'block-1' } ]

export default operandData